export default __webpack_public_path__ + "static/media/3by3.97982937.png";